import {
  SERVICE_ICON,
  WATER_MANAGEMENT_ICON,
  RENEWABLE_ENERGY_ICON,
  INDUSTRY_ICON,
  FOUNTAINS_ICON,
  ENERGY_ICON,
  CENTRAL_DISPATCHING_ICON,
} from "@/components/icons/icons";
import { ImagesEnum } from "@/model/enum/ImagesEnum";
import { RoutesEnum } from "@/model/enum/RoutesEnum";
import { SolutionTypeEnum } from "@/model/enum/SolutionTypeEnum";

export const servis = {
  nameKey: "solutions:servis.name",
  descriptionKey: "solutions:servis.description",
  href: `${RoutesEnum.SOLUTIONS}/${SolutionTypeEnum.SERVIS_A_TECHNICKA_SPRAVA}`,
  icon: SERVICE_ICON,
  imageUrl: ImagesEnum.SERVIS_A_TECHNICKA_SPRAVA,
  type: SolutionTypeEnum.SERVIS_A_TECHNICKA_SPRAVA,

  detailsPageHeroDescriptionKey: "solutions:servis.detailsPageHeroDescription",
  experienceKey: "solutions:servis.experience",
  experiencePointsKey: "solutions:servis.experiencePoints",
  ourFocusDescriptionKey: "solutions:servis.ourFocusDescription",
  ourFocusPoints: [
    {
      icon: WATER_MANAGEMENT_ICON,
      titleKey: "solutions:servis.ourFocusPoints.0.title",
      descriptionKey: "solutions:servis.ourFocusPoints.0.description",
    },
    {
      icon: RENEWABLE_ENERGY_ICON,
      titleKey: "solutions:servis.ourFocusPoints.1.title",
      descriptionKey: "solutions:servis.ourFocusPoints.1.description",
    },
    {
      icon: INDUSTRY_ICON,
      titleKey: "solutions:servis.ourFocusPoints.2.title",
      descriptionKey: "solutions:servis.ourFocusPoints.2.description",
    },
    {
      icon: FOUNTAINS_ICON,
      titleKey: "solutions:servis.ourFocusPoints.3.title",
      descriptionKey: "solutions:servis.ourFocusPoints.3.description",
    },
    {
      icon: ENERGY_ICON,
      titleKey: "solutions:servis.ourFocusPoints.4.title",
      descriptionKey: "solutions:servis.ourFocusPoints.4.description",
    },
    {
      icon: CENTRAL_DISPATCHING_ICON,
      titleKey: "solutions:servis.ourFocusPoints.5.title",
      descriptionKey: "solutions:servis.ourFocusPoints.5.description",
    },
  ],
  sectionWithImage: null,
  section: [
    {
      subtitleKey: "solutions:servis.section.0.subtitle",
      titleKey: "solutions:servis.section.0.title",
      descriptionKey: "solutions:servis.section.0.description",
      sectionPointsKey: "solutions:servis.section.0.sectionPoints",
    },
  ],
  solutionsForTopic: [
    {
      titleKey: "solutions:servis.solutionsForTopic.title",
      descriptionKey: "solutions:servis.solutionsForTopic.description",
      pointsKey: "solutions:servis.solutionsForTopic.points",
    },
  ],
};
